<template>
  <div>
    <input type="hidden" :name="filtername" :value="selected" />

    <ul>
      <li v-for="selection  in this.selections">
        <input
          type="checkbox"
          name="style"
          :value="selection.specificationPropertyMasterDataId"
          v-model="selected"
        />
        <label v-html="selection.title"></label>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    items: String,
    filterKey: String,
    specificationPropertyMasterDataIds: String
  },
  data: () => ({
    selected: []
  }),
  created() {
    // console.log("specificationId", this.specificationId);
    // console.log("selections", this.selections);
    if(this.specificationPropertyMasterDataIds.length){
      this.selected = this.specificationPropertyMasterDataIds.split(',');
    }
  },
  computed: {
    selections: function() {
      return JSON.parse(this.items);
    },
    filtername: function() {
      return "filters[" + this.filterKey + "]";
    }
  }
};
</script>